import styled from 'styled-components';

const ErrorLabel = styled.label`
  color: var(--color-red-400);
  margin-top: var(--spacing-8);
`;

export default ErrorLabel;
